<template>
    <section class="hero is-fullheight white-bg">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <div id="login_block">
                        <h3 class="login_title title has-text-grey">{{ $t('modules.auth.login.ssoLoading') }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'SsoCallback',
    mounted(){
        const code = this.$route.query.code

        if (!code){
            this.redirectToLogin('sso_missing_code')
            return
        }

        this.$store.dispatch('UserStore/ssoLogin', code)
        .then((res) => {
            if(res && res.status == 200){
                this.$router.push('/')
            }else{
                this.redirectToLogin(this.getErrorCode(res))
            }
        })
    },
    methods: {
        getErrorCode(res){
            if (res && res.response && res.response.data && res.response.data.error){
                return res.response.data.error
            }

            return 'saml exchange failed'
        },
        redirectToLogin(error){
            this.$router.push({
                path: '/login',
                query: { error: error }
            })
        }
    }
}
</script>

<style lang="scss">
#login_block{
    margin-bottom: 150px;
    .login_title {
        font-size: 3rem;
        text-transform: uppercase;
        color: $grey-light!important;
        margin-bottom: 80px;
    }
}
.white-bg{
    background: white;
}
</style>
